(() => {
  const dialog = document.getElementById('dc-tm-popup');
  if (!dialog || !dialog.showModal || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const key = 'dc-tmarker-launch-20261006';
  let previousOverflow = '', trigger = null;
  const remember = () => { try { localStorage.setItem(key, String(Date.now())); } catch (_) {} };
  const recentlyShown = () => {
    try { const time = Number(localStorage.getItem(key)); return time > 0 && Date.now() - time < 86400000; }
    catch (_) { return false; }
  };
  dialog.querySelector('.dc-tm-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    remember();
    if (trigger && trigger.isConnected) trigger.focus({preventScroll: true});
  });
  dialog.querySelector('a').addEventListener('click', remember);
  const show = () => {
    if (!dialog.isConnected || recentlyShown()) return;
    if (document.hidden || document.querySelector('dialog[open], details[open] .search-modal, .menu-drawer-container[open], cart-drawer.active')) {
      window.setTimeout(show, 3000);
      return;
    }
    trigger = document.activeElement;
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    dialog.focus({preventScroll: true});
    document.body.style.overflow = 'hidden';
    remember();
  };
  window.setTimeout(show, 4000);
})();
